module.exports = __webpack_public_path__ + "img/img_tz@2x.e1620a8f.png";